import { CircularProgress } from '@material-ui/core';
import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.main`
  max-height: calc(100vh - 64px);

  display: flex;
  flex-direction: column;

  h1 {
    margin-bottom: 0px;
  }

  h2 {
    font-family: 'Sora';
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: var(--color-navy-blue);
  }

  .box {
    width: fit-content;
    height: 45px;
    padding: 10px 20px;
    background: transparent;
    border: 2px solid var(--color-gray-900);
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;

    font-size: 15px;
    color: var(--color-blue-medium-dark);
    font-weight: 600;
    font-family: 'Sora';
    white-space: nowrap;
    transition: all 0.2s ease-in-out;
  }

  .box:hover {
    border-color: var(--color-blue-opacity-50);
  }

  .continue {
    color: #329bfc;
    background: ${() => transparentize(0.9, '#329bfc')};
  }

  .header {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    margin-bottom: 30px;
    flex-wrap: wrap;

    @media (min-height: 800px) {
      margin-bottom: 55px;
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    gap: 40px;
    overflow: auto;
    padding: 0px 24px 24px;

    @media (min-width: 768px) {
      padding: 0px 30px 30px;
    }

    scrollbar-width: thin;
    scrollbar-color: black transparent;

    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      padding: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #a1a1a1;
      border-radius: 10px;
    }
  }

  .companies,
  .scheduling,
  .form_of_payment,
  .discount_coupon,
  .discount_on_the_outside {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .companies-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }

  .scheduling {
    p {
      color: var(--color-navy-blue);
      font-weight: 400;
    }
    strong {
      font-weight: 700;
    }
  }

  .form_of_payment {
    .forms {
      display: grid;
      max-width: 500px;
      grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
      grid-gap: 10px;

      .box {
        width: auto;
        max-width: 500px;
        color: var(--color-alba-grandeza);
      }
    }

    img {
      height: 32px;
      width: 32px;
    }

    .money_change,
    .pix {
      width: auto;
      max-width: 500px;
      justify-content: space-between;

      p {
        font-weight: 400;

        strong {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }

  .coupon {
    display: flex;
    align-items: center;
    min-width: 320px;
    width: fit-content;
    justify-content: space-between;
    padding: 12px 12px 12px 22px;
    border: 2px solid var(--color-blue);
    border-radius: 5px;

    button {
      font-size: 11px;
      font-weight: 400;
      padding: 11px;
    }
  }

  .discount_on_the_outside {
    input {
      max-width: 500px;
    }
  }

  .comments {
    display: flex;
    flex-direction: column;
    gap: 15px;

    textarea {
      max-width: 500px;
      min-height: 150px;
    }
  }
`;

export const CustomCircularProgress = styled(CircularProgress)`
  color: var(--color-blue);
`;

export const CustomCheck = styled.button<{
  selected?: boolean;
  disabled?: boolean;
}>`
  transition: all 0.2s ease-in-out;

  ${(p) =>
    p.selected &&
    css`
      border-color: var(--color-blue) !important;
      color: var(--color-blue-medium-dark) !important;
    `}

  ${(p) =>
    p.disabled &&
    css`
      color: var(--color-back-opacity-10) !important;
      border-color: var(--color-back-opacity-10) !important;
      cursor: not-allowed;
    `}
`;

export const CartButton = styled.button`
  position: fixed;
  bottom: 8px;
  z-index: 2;
  right: 50%;
  transform: translateX(50%);
  display: flex;
  background-color: var(--color-blue);
  color: var(--color-gray-900);
  border-radius: 5px;
  cursor: pointer;
  gap: 8px;
  align-items: center;
  padding: 12px;
  width: 90%;
  border: none;

  p {
    flex: 1;
    font-weight: 600;
    white-space: nowrap;
    font-size: 16px;
  }

  p:nth-child(1) {
    text-align: start;
  }

  p:nth-child(2) {
    text-align: center;
  }

  p:nth-child(3) {
    text-align: end;
  }

  &:disabled,
  &[disabled] {
    background: var(--color-gray-800);
  }
`;
